import getApiClient from '@/plugins/api-client'
import { format } from 'date-fns'

export default {
    loadCharts: function () {
        const self = this,
            api = getApiClient(self.$store),
            parameters = {}

        self.filters['createdAt[before]'] = self.filters['month[before]']
        self.filters['createdAt[after]'] = self.filters['month[after]']
        Object.keys(self.filters).forEach(filter => {
            if (self.filters[filter]) {
                parameters[filter] = self.filters[filter]
            }
        })

        if(parameters['month[after]']){
            parameters['month[after]'] += ' 00:00:00'
            parameters['createdAt[after]'] += ' 00:00:00'
        }

        if(parameters['month[before]']) {
            parameters['month[before]'] += ' 23:59:59'
            parameters['createdAt[before]'] += ' 23:59:59'
        }

        api.get('/incomplete_accounts', {
            params: parameters
        })
            .then(result => {
                self.mountChart(result.data['hydra:member'])

                api.get('/users', {
                    params: {
                        page: self.currentPage,
                        itemsPerPage: self.itemsPerPage,
                        'cpf[exists]': false,
                        'order[createdAt]': self['order[createdAt]'],
                        ... parameters
                    }
                })
                    .then(workProfilesResult => {
                        self.totalPages = Math.ceil(workProfilesResult.data['hydra:totalItems'] / self.itemsPerPage)
                        self.profiles = workProfilesResult.data['hydra:member']
                    })
            })
            .catch(error => {
                console.log(error)
            })
    },

    mountChart: function (data) {
        const self = this
        let roles = ['ROLE_CONTRACTOR', 'ROLE_PROFESSIONAL']

        roles.forEach(role => {
            self.charts[role]['total'] = 0
            self.charts[role]['months'] = {}

            data.filter(item => {
                return item.roles.includes(role)
            }).forEach(filteredItem => {
                let month = format(new Date(filteredItem.month), 'MMM-yyyy')
                self.charts[role]['months'][month] = filteredItem.total
                self.charts[role]['total'] += filteredItem.total
            })
        })
    },

    setRole(role) {
        this.filters.roles = role.split(',')
    },

    clearFilters() {
        this.filters.roles = ['ROLE_CONTRACTOR', 'ROLE_PROFESSIONAL']
        this.filters['month[after]'] = null
        this.filters['month[before]'] = null

        this.loadCharts()
    },

    updatePage: function(page) {
        this.currentPage = page
    }
}
